<template>
  <section>
    <v-toolbar color="#9190b5" dark prominent src="https://picsum.photos/1920/1080?random">
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(145,144,181,.7), rgba(25,32,72,.7)"></v-img>
      </template>
      <v-toolbar-title>{{ $route.name }}</v-toolbar-title>

      <template v-slot:extension>
        <v-text-field hide-details clearable solo-inverted placeholder="Search" dense v-model="table_data.search"/>
      </template>
    </v-toolbar>

    <v-container fluid>
      <v-row>
        <v-col cols="12" md="3">
          <v-card>
            <v-card-text>
              <date-field input-class="mx-2" flat dense solo-inverted label="From" v-model="date_from"></date-field>
              <date-field input-class="mx-2" flat dense solo-inverted label="Till" v-model="date_to"></date-field>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="9" class="pl-md-0">
          <v-card>
            <v-data-table :headers="table_data.headers"
                          :items="table_data.items"
                          :search="table_data.search">
              <template v-slot:item.created_at="{ value }">
                {{ $moment(value).format('DD/MM/YYYY hh:mm A')}}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn small color="primary" class="box-shadow"
                       @click="openSelectedItemDialog(item)">open</v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>

    </v-container>

    <v-dialog v-model="selected_item_dialog" @click:outside="closeSelectedItemDialog">
      <v-form @submit="saveSelectedItemChanges">
        <v-card v-if="selected_item">
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="closeSelectedItemDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ selected_item.external_id }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text type="submit" color="success">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-card-text>
            <v-row>
              <v-col>
                <v-data-table :headers="selected_item_headers"
                              :items="selected_item.session_types"
                              :items-per-page="selected_item.session_types.length"
                              disable-pagination
                              hide-default-footer
                              dense
                >
                  <template v-slot:item.sum="{ item }">
                    {{ item.price * item.count }}
                  </template>
                </v-data-table>
              </v-col>

              <v-col>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Invoice ID</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>{{ selected_item.external_id }}</v-list-item-action>
                </v-list-item>
                <v-divider/>
                <v-list-item v-if="selected_item.user">
                  <v-list-item-content>
                    <v-list-item-subtitle>User</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>{{ selected_item.user.full_name }}</v-list-item-action>
                </v-list-item>
                <v-divider/>
                <v-list-item v-if="selected_item.user">
                  <v-list-item-content>
                    <v-list-item-subtitle>Email</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>{{ selected_item.user.email }}</v-list-item-action>
                </v-list-item>
                <v-divider/>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Date</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ $moment(selected_item.created_at).format('DD/MM/YYYY hh:mm A')}}
                  </v-list-item-action>
                </v-list-item>
                <v-divider/>

                <!--                <v-list-item>-->
                <!--                  <v-list-item-content>-->
                <!--                    <v-list-item-subtitle>Status</v-list-item-subtitle>-->
                <!--                  </v-list-item-content>-->
                <!--                  <v-list-item-action>{{ selected_item.status }}</v-list-item-action>-->
                <!--                </v-list-item>-->
                <!--                <v-divider/>-->

                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Amount</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>{{ selected_item.amount }}</v-list-item-action>
                </v-list-item>
                <v-divider/>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Tax amount</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>{{ selected_item.tax_amount }}</v-list-item-action>
                </v-list-item>
                <v-divider/>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle>Total</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>{{ selected_item.total }}</v-list-item-action>
                </v-list-item>

                <v-divider class="pb-3"/>

                <v-select class="mx-1" v-model="selected_item.status"
                          :items="status_options"
                          outlined
                          hide-details
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
  </section>
</template>

<script>
export default {
  data: () => ({
    table_data: {
      headers: [
        { text: 'External ID', value: 'external_id' },
        { text: 'User', value: 'user.full_name' },
        { text: 'Email', value: 'user.email' },
        { text: 'Description', value: 'description' },
        // { text: 'Amount', value: 'amount' },
        // { text: 'Tax Amount', value: 'tax_amount' },
        { text: 'Total', value: 'total' },
        { text: 'Date', value: 'created_at' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sort: false },
      ],
      items: [],
      search: '',
    },
    date_from: '',
    date_to: '',
    selected_item: null,
    selected_item_dialog: false,
    selected_item_headers: [
      { text: 'Session type', value: 'short_name' },
      { text: 'Count', value: 'count' },
      { text: 'Price', value: 'price' },
      { text: 'Sum', value: 'sum' },
    ],
    status_options: [
      { text: 'Created', value: 'created' },
      { text: 'Failed', value: 'failed' },
      { text: 'Success', value: 'success' },
    ],
  }),
  watch: {
    'date_from': function(oldVal, val) {
      if(oldVal !== null && val !== null){
        this.loadData()
      }
    },
    'date_to': function(oldVal, val) {
      if(oldVal !== null && val !== null){
        this.loadData()
      }
    },
  },
  created() {
    this.date_from = this.$currentTime().subtract(1, 'months').format('YYYY-MM-DD')
    this.date_to = this.$currentTime().add(1, 'days').format('YYYY-MM-DD')
    this.loadData()
  },
  methods: {
    async loadData() {
      this.table_data.items = await this.axios.get(`api/invoices`, {
        params: {
          date_from: this.date_from,
          date_to: this.date_to
        }})
          .then(({data}) => data.data)
    },
    async openSelectedItemDialog(item){
      this.selected_item = await this.axios.get(`api/invoices/${item.id}`)
          .then(({data}) => data.data)
      // this.selected_item = item
      this.selected_item_dialog = true
    },
    closeSelectedItemDialog() {
      this.selected_item_dialog = false
      this.selected_item = null
    },
    saveSelectedItemChanges(e) {
      e.preventDefault()
      this.axios.put(`api/invoices/${this.selected_item.id}`, {
        status: this.selected_item.status,
      })
          .then(({data}) => {
            this.selected_item = data.data
            this.$notify('Success!', 'success')
            this.loadData()
            this.closeSelectedItemDialog()
          })
    }
  }
}
</script>
